/**
 * Takes a string that represents a name or series of names and returns an array of names that is compatible with citation-js
 *
 * @param {string} name or delimited list of names
 * @returns {object} Object for creating citation
 */
const formatNames = (namesString) => {
  let namesStringSplit = (namesString || '').split(/&|,|;|\s+and\s+/);
  let namesArray = [];

  for (let name of namesStringSplit) {
    name = name.trim();
    if (name.length) {
      namesArray.push({ name });
    }
  }

  return namesArray;
};

/**
 * Formats book metadata into object compatible with citation-js
 *
 * @param {Book} book object
 * @returns {object} Object for creating citation
 */
const makeCitationObject = (book) => {
  // Use the current url, minus query parameters.
  let url = window.location.href.split('?')[0];
  for (let hostMatch of ['chromatic.com', 'localhost', 'testing.com']) {
    if (window.location.host.includes(hostMatch)) {
      url = 'http://test.url';
      break;
    }
  }

  // Default to using the author field.
  let author = formatNames(book.author);

  // If a first and last name are available, use that instead.
  if (book.authorFirst && book.authorLast) {
    author = {
      name: `${book.authorFirst} ${book.authorLast}`,
      firstname: book.authorFirst,
      lastname: book.authorLast,
    };
  }

  return {
    title: book.title,
    year: `${book.year}`,
    type: 'webpage',
    link: [
      {
        url,
      },
    ],
    author,
    // For properties that can be lists, run them through a parser.
    editor: formatNames(book.editors),
    translator: formatNames(book.translators),
    publisher: book.publisher,
    volume: book.volume,
  };
};

export { formatNames };
export default makeCitationObject;
